import React from 'react';

function EmbedMultimediaIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="18"
      viewBox="0 0 15 18"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" transform="translate(-964 -2145)">
          <g transform="translate(926 1975)">
            <path d="M39.66 170a1.293 1.293 0 00-.707.203c-.34.208-.57.566-.629.97l-.048.623-.08.862-.035.469-.03.541-.025.614-.022.688-.009.37a92.755 92.755 0 00-.075 3.654c0 .877.014 1.784.042 2.72l.048 1.318.06 1.306.045.782.06.823.061.687.005.043c.007.469.252.898.643 1.124.213.136.458.206.707.203.163-.014.322-.055.472-.124a49.017 49.017 0 0012.384-7.757c.317-.276.492-.693.471-1.125a1.284 1.284 0 00-.471-1.056l-.056-.057-.156-.145-.342-.297-.256-.212-.426-.338-.989-.76-.239-.181a55.68 55.68 0 00-2.625-1.867c-.921-.622-2.039-1.3-3.353-2.035a39.82 39.82 0 00-3.942-1.933 1.424 1.424 0 00-.482-.113z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EmbedMultimediaIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/EmbedMultimedia.js